import React from "react";
import SettingsContainer from "../../containers/Settings";

function Settings(props) {
  return <SettingsContainer {...props} />;
}

export default Settings;
